class PressSlider extends HTMLElement {
    constructor() {
        super();
      }
    
      connectedCallback() {
        window.loadSwiper.then((swiperLib) => {
          this.swiperLib = swiperLib;
    
          this._initCarousel();
        });
      }
    
      disconnectedCallback() {}
  
    _initCarousel() {

    const slides = this.querySelectorAll(".swiper-slide");
    const slideCount = slides.length;

    // Only init swiper on desktop if more than 4 tiles
    const shouldInitCarousel =
        window.innerWidth < 768 && slideCount > 1;

    const nextBtn = this.querySelector("[data-navigation-next]");
    const prevBtn = this.querySelector("[data-navigation-previous]");

    if (!shouldInitCarousel) {
        // Hide arrows if Swiper isn't initialized
        if (nextBtn) nextBtn.style.display = "none";
        if (prevBtn) prevBtn.style.display = "none";
        return;
    }
      const { Swiper } = this.swiperLib;
  
      this.swiper = new Swiper(this.querySelector(".swiper"), {
        slidesPerView: 2.3,
        centeredSlides: true,
        loop: true,
        spacespaceBetween: 56,
      });
    }
  }
  
  if (!customElements.get("featured-press")) {
    customElements.define("featured-press", PressSlider);
  }
  